import { Box, Button, Flex, Text, useDisclosure } from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { CaravanFormModal } from "../forms/CaravanFormModal";
import { CaravanStockDTO } from "../types";
import { formatNumberWithPounds } from "../utils";
import { decodeHtmlEntities } from "../utils/decodeHtmlEntities";
import { CenteredExpandedImage } from "./CenteredExpandedImage";

export const CaravanOverview: React.FC<{ caravan: CaravanStockDTO }> = ({ caravan }) => {
  const { ID, manufacturer, model, price, image, status, longDesc } = caravan;

  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <CaravanFormModal isOpen={isOpen} onClose={onClose} caravanId={ID} />

      <Flex flexDir="row" borderWidth={1}>
        <Flex width="40%" onClick={() => navigate(ID)} cursor="pointer">
          <CenteredExpandedImage src={`${image}&width=800`} maxH={{ base: "auto", md: "305px" }} />
        </Flex>

        <Flex width="60%" flexDir="column">
          <Box p={4}>
            <Link to={ID} style={{ width: "100%" }}>
              <Text fontSize="28px">
                {manufacturer}, {model}
              </Text>
            </Link>
            <Text>{status}</Text>
            <Text mb={2}>Reference: {ID}</Text>
            <Text
              noOfLines={2}
              dangerouslySetInnerHTML={{
                __html: decodeHtmlEntities(longDesc),
              }}
            />
            <Link to={ID} style={{ width: "100%" }}>
              <Button variant="blue" mt={2} color="white">
                Read more
              </Button>
            </Link>
            <Text fontSize="28px" display={{ base: "block", md: "none" }} mt={4}>
              {formatNumberWithPounds(price)}
            </Text>
          </Box>
          <Flex bg="gray.50" mt="auto" p={4} justify="space-between" borderTopWidth={1}>
            <Text fontSize="28px" display={{ base: "none", md: "block" }}>
              {formatNumberWithPounds(price)}
            </Text>
            <Button
              onClick={onOpen}
              w={{ base: "100%", md: "inherit" }}
              variant="blue"
              color="white"
              borderRadius="20px"
              fontSize="20px"
              p={4}
            >
              Contact Seller
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};
